import { selectCurrentUser } from 'ducks/currentUser/selectors/selectCurrentUser'
import { doFetchRoomsByIds } from 'ducks/chat/actions/rooms'
import { selectIsInChat } from 'selectors/location'
import { selectWidgetsById } from 'ducks/widgets/selectors/widgets'
import { selectChannelTypeFromUrl } from 'ducks/channels/selectors'
import { selectLastUpdatedAt } from '../selectors'
import selectCurrentConversationId from '../selectors/selectCurrentConversationId'
import { SEARCH_SYNC } from '../actionTypes'
import { getAddedConversationIds } from '../utils/query'

export function doSyncSearches(mxEvent) {
  return async (dispatch, getState) => {
    const state = getState()
    const {
      last_updated_at: lastUpdatedAt,
      searches = {},
      unread = {},
    } = mxEvent.getContent()
    const currentLastUpdatedAt = selectLastUpdatedAt(state)
    const currentUser = selectCurrentUser(state)
    const addedConversationIds = getAddedConversationIds(searches)
    const currentConversationId = selectCurrentConversationId(state)
    const widgetsById = selectWidgetsById(state)
    const isInChat = selectIsInChat(state)
    const pageChannelType = selectChannelTypeFromUrl(state)
    if (addedConversationIds.length > 0)
      await dispatch(doFetchRoomsByIds({ ids: addedConversationIds }))
    return dispatch({
      type: SEARCH_SYNC,
      payload: {
        currentLastUpdatedAt,
        lastUpdatedAt,
        searches,
        currentUser,
        unread,
        isInChat,
        currentConversationId,
        widgetsById,
        pageChannelType,
      },
    })
  }
}
